import { Button, Col, Modal, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { 
  CheckOutlined,
  UserAddOutlined,
  ClockCircleOutlined,
  TrophyOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
  DollarCircleOutlined,
  CheckCircleOutlined,
  SafetyCertificateOutlined,
  HourglassOutlined,
  PauseCircleOutlined,
  StopOutlined,
  EditOutlined
} from '@ant-design/icons';
import { ChangeReserveStatusByAdmin_Reserve_Api } from '../../API/ReserveApi';

const { Option } = Select;

export const ReserveStatus = ({ setLoading, showMessage, reserveId, reserveStatus, adminMode = false }) => {
  const [statusValue, setStatusValue] = useState('');

  useEffect(() => {
    setStatusValue(reserveStatus ?? '');
  }, [reserveStatus]);

  // تعریف رنگ‌ها، آیکون‌ها و عنوان‌های فارسی برای هر وضعیت
  const statusConfig = {
    "Register": {
      color: "#dc3545",
      icon: <EditOutlined />,
      label: "ثبت اولیه"
    },
    "OtherEntered": {
      color: "#343a40",
      icon: <UserAddOutlined />,
      label: "ورود نفرات"
    },
    "TimeSelected": {
      color: "#343a40",
      icon: <ClockCircleOutlined />,
      label: "انتخاب زمان"
    },
    "LotteryWaiting": {
      color: "#ffc107",
      icon: <HourglassOutlined />,
      label: "در انتظار قرعه کشی"
    },
    "WonInLottery": {
      color: "#28a745",
      icon: <TrophyOutlined />,
      label: "برنده شده در قرعه کشی"
    },
    "FailInLottery": {
      color: "#dc3545",
      icon: <CloseCircleOutlined />,
      label: "برنده نشده در قرعه کشی"
    },
    "FileUploadWaiting": {
      color: "#36ac51ff",
      icon: <FileTextOutlined />,
      label: "در انتظار ارسال مدارک"
    },
    "PayWaiting": {
      color: "#ffc107",
      icon: <DollarCircleOutlined />,
      label: "در انتظار پرداخت"
    },
    "Payed": {
      color: "#29bb8fff",
      icon: <CheckCircleOutlined />,
      label: "پرداخت شده"
    },
    "Completed": {
      color: "#176b4bff",
      icon: <SafetyCertificateOutlined />,
      label: "قطعی شده"
    },
    "Accepted": {
      color: "#007bff",
      icon: <CheckCircleOutlined />,
      label: "پذیرش شده"
    },
    "Cancel": {
      color: "#d35e0fff",
      icon: <PauseCircleOutlined />,
      label: "لیست انتظار"
    },
    "RejectByAdmin": {
      color: "#cc2132ff",
      icon: <StopOutlined />,
      label: "انصراف قطعی"
    }
  };

  const stringToValue = (st) => {
    switch (st) {
      case "Register": return 0;
      case "OtherEntered": return 1;
      case "TimeSelected": return 2;
      case "LotteryWaiting": return 3;
      case "WonInLottery": return 4;
      case "FailInLottery": return 5;
      case "FileUploadWaiting": return 6;
      case "PayWaiting": return 7;
      case "Payed": return 8;
      case "Completed": return 9;
      case "Accepted": return 10;
      case "Cancel": return 11;
      case "RejectByAdmin": return 12;
      default: return null;
    }
  };

  const handleChange = (value) => {
    setStatusValue(value);
  };

  const submitChange = async () => {
    if (!statusValue) {
      showMessage('لطفاً یک وضعیت معتبر انتخاب کنید.', 'error');
      return;
    }

    const statusNumber = stringToValue(statusValue);
    if (statusNumber === null) {
      showMessage('وضعیت انتخاب شده نامعتبر است.', 'error');
      return;
    }

    setLoading(true);
    try {
      const data = await ChangeReserveStatusByAdmin_Reserve_Api({
        reserveId,
        status: statusNumber
      });
      setLoading(false);

      if (data?.messageStatus === "Successful") {
        showMessage(data.message, "Successful");
      } else {
        showMessage(data?.message || 'خطا در تغییر وضعیت.', "error");
      }
    } catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error");
    }
  };

  // لیست وضعیت‌های قابل انتخاب در ادمین
  const adminStatusOptions = [
    "LotteryWaiting",
    "WonInLottery", 
    "FailInLottery",
    "FileUploadWaiting",
    "PayWaiting",
    "Payed",
    "Completed",
    "Accepted",
    "Cancel",
    "RejectByAdmin"
  ];

  return (
    <>
      {adminMode && (localStorage.getItem('role') === 'SuperAdmin' || localStorage.getItem('role') === 'Admin') ? (
        <Row>
          <Col span={16}>
            <Select
              style={{ width: '80%' }}
              onChange={handleChange}
              value={statusValue}
              placeholder="انتخاب وضعیت"
              showSearch
              filterOption={(input, option) => {
                // جستجو در متن فارسی
                const persianText = statusConfig[option.value]?.label || '';
                return persianText.includes(input);
              }}
            >
              {adminStatusOptions.map(status => {
                const config = statusConfig[status];
                return (
                  <Option key={status} value={status}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ color: config.color, marginRight: '6px' }}>
                        {config.icon}
                      </span>
                      <span>{config.label}</span>
                    </div>
                  </Option>
                );
              })}
            </Select>
          </Col>

          <Col span={8}>
            <Button
              style={{ width: '98%' }}
              className='btn-primary'
              onClick={() => {
                Modal.confirm({
                  title: 'آیا از تغییر وضعیت درخواست اطمینان دارید؟',
                  content: `تغییر وضعیت به: ${statusConfig[statusValue]?.label || statusValue}`,
                  onOk: () => { submitChange(); },
                  footer: (_, { OkBtn, CancelBtn }) => (
                    <>
                      <CancelBtn />
                      <OkBtn />
                    </>
                  ),
                });
              }}
            >
              <CheckOutlined />
              ذخیره
            </Button>
          </Col>
        </Row>
      ) : (
        <>
          {/* نمایش وضعیت برای کاربران عادی */}
          {Object.entries(statusConfig).map(([status, config]) => 
            reserveStatus === status && (
              <div key={status}>
                <span className='no-print'>
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      backgroundColor: `${config.color}15`,
                      color: config.color,
                      padding: '4px 12px',
                      borderRadius: '6px',
                      border: `1px solid ${config.color}30`,
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    <span style={{ fontSize: '14px' }}>
                      {config.icon}
                    </span>
                    <span>{status === "Completed" || status === "Accepted" ? <b>{config.label}</b> : config.label}</span>
                  </div>
                </span>
                <span className='only-print' style={{ color: config.color }}>
                  {status === "Completed" || status === "Accepted" ? 
                    <b>{config.label}</b> : config.label}
                </span>
              </div>
            )
          )}
        </>
      )}
    </>
  );
};







/*import { Button, Col, Modal, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { ChangeReserveStatusByAdmin_Reserve_Api } from '../../API/ReserveApi';

const { Option } = Select;

export const ReserveStatus = ({ setLoading, showMessage, reserveId, reserveStatus, adminMode = false }) => {
  const [statusValue, setStatusValue] = useState('');

  useEffect(() => {
    setStatusValue(reserveStatus ?? '');
  }, [reserveStatus]);

  // نگاشت رشته -> عدد برای ارسال به API
  const stringToValue = (st) => {
    switch (st) {
      case "Register": return 0;
      case "OtherEntered": return 1;
      case "TimeSelected": return 2;
      case "LotteryWaiting": return 3;
      case "WonInLottery": return 4;
      case "FailInLottery": return 5;
      case "FileUploadWaiting": return 6;
      case "PayWaiting": return 7;
      case "Payed": return 8;
      case "Completed": return 9;
      case "Accepted": return 10;
      case "Cancel": return 11;
      case "RejectByAdmin": return 12;
      default: return null;
    }
  };

  const handleChange = (value) => {
    setStatusValue(value);
  };

  const submitChange = async () => {
    // جلوگیری از ارسال مقدار خالی یا نامعتبر
    if (!statusValue) {
      showMessage('لطفاً یک وضعیت معتبر انتخاب کنید.', 'error');
      return;
    }

    const statusNumber = stringToValue(statusValue);
    if (statusNumber === null) {
      showMessage('وضعیت انتخاب شده نامعتبر است.', 'error');
      return;
    }

    setLoading(true);
    try {
      const data = await ChangeReserveStatusByAdmin_Reserve_Api({
        reserveId,
        status: statusNumber
      });
      setLoading(false);

      if (data?.messageStatus === "Successful") {
        showMessage(data.message, "Successful");
      } else {
        showMessage(data?.message || 'خطا در تغییر وضعیت.', "error");
      }
    } catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error");
    }
  };

  return (
    <>
      {adminMode && (localStorage.getItem('role') === 'SuperAdmin' || localStorage.getItem('role') === 'Admin') ? (
        <Row>
          <Col span={16}>
            <Select
              style={{ width: '80%' }}
              onChange={handleChange}
              optionFilterProp="children"
              value={statusValue}
              placeholder="انتخاب وضعیت"
              showSearch
            >
              <Option value="LotteryWaiting">در انتظار قرعه کشی</Option>
              <Option value="WonInLottery">برنده شده در قرعه کشی</Option>
              <Option value="FailInLottery">برنده نشده در قرعه کشی</Option>
              <Option value="FileUploadWaiting">در انتظار ارسال مدارک</Option>
              <Option value="PayWaiting">در انتظار پرداخت</Option>
              <Option value="Payed">پرداخت شده</Option>
              <Option value="Completed">قطعی شده</Option>
              <Option value="Accepted">پذیرش شده</Option>
              <Option value="Cancel">لیست انتظار</Option>
              <Option value="RejectByAdmin">انصراف قطعی</Option>
            </Select>
          </Col>

          <Col span={8}>
            <Button
              style={{ width: '98%' }}
              className='btn-primary'
              htmlType="submit"
              onClick={() => {
                Modal.confirm({
                  title: 'آیا از تغییر وضعیت درخواست اطمینان دارید؟',
                  onOk: () => { submitChange(); },
                  footer: (_, { OkBtn, CancelBtn }) => (
                    <>
                      <CancelBtn />
                      <OkBtn />
                    </>
                  ),
                });
              }}
            >
              <CheckOutlined />
              ذخیره
            </Button>
          </Col>
        </Row>
      ) : (
        <>
          {/* نمایش وضعیت برای کاربران عادی (همان بخش قبلی شما) *//*}
          {reserveStatus === "Register" && <><span style={{ color: "#dc3545" }} className='no-print'>ثبت اولیه </span><span className='only-print'>ثبت اولیه </span></>}
          {reserveStatus === "OtherEntered" && <><span style={{ color: "#343a40" }} className='no-print'>ورود نفرات</span><span className='only-print'>ورود نفرات </span></>}
          {reserveStatus === "TimeSelected" && <><span style={{ color: "#343a40" }} className='no-print'>انتخاب زمان</span><span className='only-print'>انتخاب زمان </span></>}
          {reserveStatus === "LotteryWaiting" && <><span style={{ color: "#ffc107" }} className='no-print'>در انتظار قرعه کشی</span><span className='only-print'>در انتظار قرعه کشی </span></>}
          {reserveStatus === "WonInLottery" && <><span style={{ color: "#28a745" }} className='no-print'>برنده شده در قرعه کشی</span><span className='only-print'> برنده شده در قرعه کشی</span></>}
          {reserveStatus === "FailInLottery" && <><span style={{ color: "#dc3545" }} className='no-print'>برنده نشده در قرعه کشی</span><span className='only-print'>برنده نشده در قرعه کشی </span></>}
          {reserveStatus === "FileUploadWaiting" && <><span style={{ color: "#36ac51ff" }} className='no-print'>در انتظار ارسال مدارک</span><span className='only-print'> در انتظار ارسال مدارک</span></>}
          {reserveStatus === "Confirmed" && <><span style={{ color: "#28a745" }} className='no-print'>تایید شده</span><span className='only-print'>تایید شده </span></>}
          {reserveStatus === "PayWaiting" && <><span style={{ color: "#ffc107" }} className='no-print'>در انتظار پرداخت</span><span className='only-print'>در انتظار پرداخت </span></>}
          {reserveStatus === "Payed" && <><span style={{ color: "#29bb8fff" }} className='no-print'>پرداخت شده</span><span className='only-print'>پرداخت شده </span></>}
          {reserveStatus === "Completed" && <><span style={{ color: "#176b4bff" }} className='no-print'><b>قطعی شده</b></span><span className='only-print'> <b>قطعی شده</b></span></>}
          {reserveStatus === "Accepted" && <><span style={{ color: "#007bff" }} className='no-print'><b>پذیرش شده</b></span><span className='only-print'> <b>پذیرش شده</b></span></>}
          {reserveStatus === "Cancel" && <><span style={{ color: "#d35e0fff" }} className='no-print'>لیست انتظار</span><span className='only-print'>لیست انتظار </span></>}
          {reserveStatus === "RejectByAdmin" && <><span style={{ color: "#cc2132ff" }} className='no-print'>انصراف قطعی</span><span className='only-print'> </span></>}
        </>
      )}
    </>
  );
};
*/
//----------------------------------------------

/*import { Button, Col, Modal, Row, Select } from 'antd'
import { Option } from 'antd/es/mentions'
import React, { useEffect, useState } from 'react'
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import { ChangeReserveStatusByAdmin_Reserve_Api } from '../../API/ReserveApi';
// ======================================================================

export const ReserveStatus = ({ setLoading,showMessage,reserveId, reserveStatus, adminMode = false }) => {
    // ======================================================================
    const [statusValue, setStatusValue] = useState();
    // ======================================================================
    useEffect(() => {
        setStatusValue(reserveStatus);
    }, [reserveStatus]);
    // ======================================================================
    const stringToValue = (st) => {
        switch (st) {
            case "Register": return 0;
            case "OtherEntered": return 1;
            case "TimeSelected": return 2;
            case "LotteryWaiting": return 3;
            case "WonInLottery": return 4;
            case "FailInLottery": return 5;
            case "FileUploadWaiting": return 6;
            case "PayWaiting": return 7;
            case "Payed": return 8;
            case "Completed": return 9;
            case "Accepted": return 10;
            case "Cancel": return 11;
            case "RejectByAdmin": return 12;
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        setStatusValue(value);
    };
    // ======================================================================
    const submitChange = async() => {
          setLoading(true);
               try {
                   const data = await ChangeReserveStatusByAdmin_Reserve_Api({ "reserveId": reserveId, "status": statusValue });
                   setLoading(false)
                   if (data.messageStatus == "Successful") {
                       showMessage(data.message, "Successful");
                   }
                   else
                       showMessage(data.message, "error")
               }
               catch (error) {
                   setLoading(false);
                   showMessage("خطا در ارتباط با سرور.", "error")
               }
    };
    // ======================================================================
    return (
        <>
            {adminMode && (localStorage.getItem('role') == 'SuperAdmin' ||
                localStorage.getItem('role') == 'Admin') ?
                <>
                    <Row>
                        <Col span={16} >
                            <Select
                                style={{ width: '80%' }}
                                onChange={handleChange}
                                optionFilterProp="children"
                                value={stringToValue(statusValue)}
                            >
                                <Option value={3}>
                                    در انتظار قرعه کشی
                                </Option>
                                <Option value={4}>
                                    برنده شده در قرعه کشی
                                </Option>
                                <Option value={5}>
                                    برنده نشده در قرعه کشی
                                </Option>
                                <Option value={6}>
                                    در انتظار ارسال مدارک
                                </Option>
                                <Option value={7}>
                                    در انتظار پرداخت
                                </Option>
                                <Option value={8}>
                                    پرداخت شده
                                </Option>
                                <Option value={9}>
                                    قطعی شده
                                </Option>
                                <Option value={10}>
                                    پذیرش شده
                                </Option>
                                <Option value={11}>
                                    لیست انتظار
                                </Option>
                                <Option value={12}>
                                    انصراف قطعی
                                </Option>
                            </Select>
                        </Col>
                        <Col span={8} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'آیا از تغییر وضعیت درخواست اطمینان دارید؟',
                                        onOk: () => { submitChange() },
                                        footer: (_, { OkBtn, CancelBtn }) => (
                                            <>
                                                <CancelBtn />
                                                <OkBtn />
                                            </>
                                        ),
                                    });
                                }}
                            >
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                    </Row>
                </> :
                <>
                    {reserveStatus == "Register" ?
                        <>
                        <span style={{ color: "#dc3545" }} className='no-print'>ثبت اولیه </span>
                        <span  className='only-print'>ثبت اولیه </span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "OtherEntered" ?
                        <>
                        <span style={{ color: "#343a40" }} className='no-print'>ورود نفرات</span>  
                        <span  className='only-print'>ورود نفرات </span>
                        </>
                        : <></>
                    
                    }
                    {reserveStatus == "TimeSelected" ?
                        <>
                        <span style={{ color: "#343a40" }} className='no-print'>انتخاب زمان</span> 
                        <span  className='only-print'>انتخاب زمان </span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "LotteryWaiting" ?
                        <>
                        <span style={{ color: "#ffc107" }} className='no-print'>در انتظار قرعه کشی</span>
                        <span  className='only-print'>در انتظار قرعه کشی </span>
                        </>
                         : <></>
                    }
                    {reserveStatus == "WonInLottery" ?
                        <>
                        <span style={{ color: "#28a745" }} className='no-print'>برنده شده در قرعه کشی</span>
                        <span  className='only-print'> برنده شده در قرعه کشی</span>
                        </>
                         : <></>
                    }
                    {reserveStatus == "FailInLottery" ?
                        <>
                        <span style={{ color: "#dc3545" }} className='no-print'>برنده نشده در قرعه کشی</span> 
                        <span  className='only-print'>برنده نشده در قرعه کشی </span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "FileUploadWaiting" ?
                        <>
                        <span style={{ color: "#36ac51ff" }} className='no-print'>در انتظار ارسال مدارک</span> 
                        <span  className='only-print'> در انتظار ارسال مدارک</span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "Confirmed" ?
                        <>
                        <span style={{ color: "#28a745" }} className='no-print'>تایید شده</span>
                        <span  className='only-print'>تایید شده </span>
                        </>
                         : <></>
                    }
                    {reserveStatus == "PayWaiting" ?
                        <>
                        <span style={{ color: "#ffc107" }} className='no-print'>در انتظار پرداخت</span> 
                        <span  className='only-print'>در انتظار پرداخت </span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "Payed" ?
                        <>
                        <span style={{ color: "#29bb8fff" }} className='no-print'>پرداخت شده</span> 
                        <span  className='only-print'>پرداخت شده </span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "Completed" ?
                        <>
                        <span style={{ color: "#176b4bff" }} className='no-print'><b>قطعی شده</b></span> 
                        <span  className='only-print'> <b>قطعی شده</b></span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "Accepted" ?
                        <>
                        <span style={{ color: "#007bff" }} className='no-print'><b>پذیرش شده</b></span> 
                        <span  className='only-print'> <b>پذیرش شده</b></span>
                        </>
                        : <></>
                    }
                    {reserveStatus == "Cancel" ?
                        <>
                        <span style={{ color: "#d35e0fff" }} className='no-print'>لیست انتظار</span>
                        <span  className='only-print'>لیست انتظار </span>
                        </>
                         : <></>
                    }
                    {reserveStatus == "RejectByAdmin" ?
                        <>
                        <span style={{ color: "#cc2132ff" }} className='no-print'>انصراف قطعی</span>
                        <span  className='only-print'> </span>
                        </>
                         : <></>
                    }
                </>
            }
        </>
    )
}
*/
